define.alias("shared/components/shared/pre-boarding/auto-trial-end/index", "media/components/shared/pre-boarding/auto-trial-end");